import { render, staticRenderFns } from "./PassComponent.vue?vue&type=template&id=b94fa25c&"
import script from "./PassComponent.vue?vue&type=script&lang=js&"
export * from "./PassComponent.vue?vue&type=script&lang=js&"
import style0 from "./PassComponent.vue?vue&type=style&index=0&id=b94fa25c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports